import { isDefined } from '@myre/common-primitives';

import {
  QuestionBase,
  type IQuestionBase,
  type SetValueOptions,
} from './question-base';

export interface IQuestionCheckbox extends IQuestionBase<boolean> {}

export class QuestionCheckbox
  extends QuestionBase<boolean>
  implements IQuestionCheckbox
{
  constructor(options: IQuestionCheckbox) {
    super(options);

    if (isDefined(this.initialValue)) {
      this.initialValue = !!this.initialValue;
    }

    if (isDefined(this.defaultValue)) {
      this.defaultValue = !!this.defaultValue;
    }

    this.elementType = 'checkbox';
  }

  public override equals(value: any): boolean {
    return this.getValue() === value;
  }

  public override getValue(): boolean {
    const value = super.getValue();

    if (isDefined(value)) {
      return !!value;
    }

    return value;
  }

  public override setValue(
    value: any,
    opts: SetValueOptions = { emitEvent: true, force: false },
  ): void {
    if (isDefined(value)) {
      value = !!value;
    }

    super.setValue(value, opts);
  }
}
